export default __webpack_public_path__ + "/dist/images/demo-card-bottom.88b8492360848545149c9a438121eabf.png";